/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcCodesRouteImport } from './routes/ac-codes'
import { Route as DiagnoseRouteImport } from './routes/diagnose'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as SolarRouteImport } from './routes/solar'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as VfdCodesRouteImport } from './routes/vfd-codes'
import { Route as FaultIdRouteImport } from './routes/fault.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AcCodesRoute = AcCodesRouteImport.update({
  id: '/ac-codes',
  path: '/ac-codes',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnoseRoute = DiagnoseRouteImport.update({
  id: '/diagnose',
  path: '/diagnose',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const SolarRoute = SolarRouteImport.update({
  id: '/solar',
  path: '/solar',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsRoute = ToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => rootRouteImport,
} as any)
const VfdCodesRoute = VfdCodesRouteImport.update({
  id: '/vfd-codes',
  path: '/vfd-codes',
  getParentRoute: () => rootRouteImport,
} as any)
const FaultIdRoute = FaultIdRouteImport.update({
  id: '/fault/$id',
  path: '/fault/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ac-codes': typeof AcCodesRoute
  '/diagnose': typeof DiagnoseRoute
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRoute
  '/solar': typeof SolarRoute
  '/tools': typeof ToolsRoute
  '/vfd-codes': typeof VfdCodesRoute
  '/fault/$id': typeof FaultIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ac-codes': typeof AcCodesRoute
  '/diagnose': typeof DiagnoseRoute
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRoute
  '/solar': typeof SolarRoute
  '/tools': typeof ToolsRoute
  '/vfd-codes': typeof VfdCodesRoute
  '/fault/$id': typeof FaultIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ac-codes': typeof AcCodesRoute
  '/diagnose': typeof DiagnoseRoute
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRoute
  '/solar': typeof SolarRoute
  '/tools': typeof ToolsRoute
  '/vfd-codes': typeof VfdCodesRoute
  '/fault/$id': typeof FaultIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ac-codes'
    | '/diagnose'
    | '/history'
    | '/library'
    | '/solar'
    | '/tools'
    | '/vfd-codes'
    | '/fault/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ac-codes'
    | '/diagnose'
    | '/history'
    | '/library'
    | '/solar'
    | '/tools'
    | '/vfd-codes'
    | '/fault/$id'
  id:
    | '__root__'
    | '/'
    | '/ac-codes'
    | '/diagnose'
    | '/history'
    | '/library'
    | '/solar'
    | '/tools'
    | '/vfd-codes'
    | '/fault/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcCodesRoute: typeof AcCodesRoute
  DiagnoseRoute: typeof DiagnoseRoute
  HistoryRoute: typeof HistoryRoute
  LibraryRoute: typeof LibraryRoute
  SolarRoute: typeof SolarRoute
  ToolsRoute: typeof ToolsRoute
  VfdCodesRoute: typeof VfdCodesRoute
  FaultIdRoute: typeof FaultIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ac-codes': {
      id: '/ac-codes'
      path: '/ac-codes'
      fullPath: '/ac-codes'
      preLoaderRoute: typeof AcCodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnose': {
      id: '/diagnose'
      path: '/diagnose'
      fullPath: '/diagnose'
      preLoaderRoute: typeof DiagnoseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solar': {
      id: '/solar'
      path: '/solar'
      fullPath: '/solar'
      preLoaderRoute: typeof SolarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools': {
      id: '/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof ToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vfd-codes': {
      id: '/vfd-codes'
      path: '/vfd-codes'
      fullPath: '/vfd-codes'
      preLoaderRoute: typeof VfdCodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fault/$id': {
      id: '/fault/$id'
      path: '/fault/$id'
      fullPath: '/fault/$id'
      preLoaderRoute: typeof FaultIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcCodesRoute: AcCodesRoute,
  DiagnoseRoute: DiagnoseRoute,
  HistoryRoute: HistoryRoute,
  LibraryRoute: LibraryRoute,
  SolarRoute: SolarRoute,
  ToolsRoute: ToolsRoute,
  VfdCodesRoute: VfdCodesRoute,
  FaultIdRoute: FaultIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

